__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@lllverse-dhsn/order";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.6.2", () => (Promise.all([__webpack_require__.e(2578), __webpack_require__.e(4868), __webpack_require__.e(6927), __webpack_require__.e(3385), __webpack_require__.e(2854)]).then(() => (() => (__webpack_require__(64868))))));
			register("@chatscope/chat-ui-kit-react", "1.8.2", () => (Promise.all([__webpack_require__.e(6775), __webpack_require__.e(6927), __webpack_require__.e(3385)]).then(() => (() => (__webpack_require__(46775))))));
			register("@life-line-lab/components-react", "1.0.43", () => (Promise.all([__webpack_require__.e(4052), __webpack_require__.e(6927), __webpack_require__.e(4819)]).then(() => (() => (__webpack_require__(74052))))));
			register("axios", "0.21.1", () => (__webpack_require__.e(9644).then(() => (() => (__webpack_require__(89644))))));
			register("classnames", "2.3.1", () => (__webpack_require__.e(2779).then(() => (() => (__webpack_require__(72779))))));
			register("classnames", "2.3.2", () => (__webpack_require__.e(4184).then(() => (() => (__webpack_require__(94184))))));
			register("file-saver", "2.0.5", () => (__webpack_require__.e(6782).then(() => (() => (__webpack_require__(46782))))));
			register("i18next", "20.3.5", () => (__webpack_require__.e(5499).then(() => (() => (__webpack_require__(45499))))));
			register("jspdf-autotable", "3.5.20", () => (Promise.all([__webpack_require__.e(1522), __webpack_require__.e(4161)]).then(() => (() => (__webpack_require__(11522))))));
			register("jspdf", "2.3.1", () => (__webpack_require__.e(1499).then(() => (() => (__webpack_require__(11499))))));
			register("jszip-utils", "0.1.0", () => (__webpack_require__.e(4131).then(() => (() => (__webpack_require__(54131))))));
			register("jszip", "3.7.1", () => (__webpack_require__.e(1297).then(() => (() => (__webpack_require__(1297))))));
			register("moment", "2.29.1", () => (Promise.all([__webpack_require__.e(288), __webpack_require__.e(7035)]).then(() => (() => (__webpack_require__(19034))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(8316), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(28316))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(8671), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(18671))))));
			register("react-i18next", "11.11.4", () => (Promise.all([__webpack_require__.e(2428), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(72428))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(2817), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(12817))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2784).then(() => (() => (__webpack_require__(2784))))));
			register("recoil", "0.1.3", () => (Promise.all([__webpack_require__.e(2732), __webpack_require__.e(6927), __webpack_require__.e(4819)]).then(() => (() => (__webpack_require__(2732))))));
			register("socket.io-client", "4.4.0", () => (__webpack_require__.e(8767).then(() => (() => (__webpack_require__(8767))))));
			register("xlsx", "0.18.5", () => (__webpack_require__.e(4333).then(() => (() => (__webpack_require__(94333))))));
			register("yup", "0.32.9", () => (Promise.all([__webpack_require__.e(3859), __webpack_require__.e(8253), __webpack_require__.e(9872)]).then(() => (() => (__webpack_require__(88253))))));
			initExternal(26458);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};